import { render, staticRenderFns } from "./thank-you.vue?vue&type=template&id=9f1d9394"
import script from "./thank-you.vue?vue&type=script&lang=js"
export * from "./thank-you.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotThankYou: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Templates/ThankYou/ThankYou.vue').default})
